// eslint-disable-next-line @typescript-eslint/no-var-requires,global-require,import/no-dynamic-require
export const APP_CONFIG = require("./config/" + process.env.REACT_APP_VARIANT).default;
window.config = APP_CONFIG;
